export enum WREX_LIST {
    /**
     * @value Numbered list
     */
    ORDERED_LIST_BUTTON = 'FRONT.TEXT_EDITOR.FORMAT.ORDERED_LIST_BUTTON',
    /**
     * @value Numbered list (%SHORTCUT%)
     */
    ORDERED_LIST_WITH_SHORTCUT = 'WREX_LIST.ORDERED_LIST_WITH_SHORTCUT',
    /**
     * @value Bulleted list
     * @description text editor insert unordered list button tooltip
     */
    UNORDERED_LIST_BUTTON = 'FRONT.TEXT_EDITOR.FORMAT.LIST_BUTTON',
    /**
     * @value Bulleted list (%SHORTCUT%)
     * @description text editor insert unordered list button tooltip
     */
    UNORDERED_LIST_WITH_SHORTCUT = 'WREX_LIST.UNORDERED_LIST_WITH_SHORTCUT',
}
